<template>
    <v-dialog v-model="showDialog" width="400px" persistent >
        <v-card flat>
            <v-card-title class="pa-1 pl-2">
                <span class="subheading font-weight-light primary--text">Create Task</span>
                <v-spacer></v-spacer>
                <v-btn
                        small
                        icon
                        flat
                        color="primary"
                        class="pa-0 ma-0"
                        @click="$emit('dismiss', true)"
                >
                    <v-icon small>close</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>

            <v-card-text>
                <v-layout column>
<!--Loading-->
                    <v-flex v-if="loadingWorkflows" class="pa-2 text-xs-center">
                        <v-progress-circular
                                :size="40"
                                :width="5"
                                color="primary"
                                indeterminate
                        ></v-progress-circular>
                    </v-flex>
<!--Loading Done-->
                    <template v-else>
<!--Select Workflow-->
                        <v-flex shrink>
                            <v-menu
                                    v-model="showSelectWorkflow"
                                    :disabled="splitTask"
                                    :width="600"
                                    max-height="600"
                                    :close-on-content-click="false"
                                    nudge-left="16"
                                    offset-y
                            >
                                <v-hover slot="activator">
                                    <v-layout
                                            row
                                            align-center
                                            slot-scope="{ hover }"
                                            style="cursor: pointer"
                                            @click="() => {}"
                                    >
                                        <v-flex shrink>
                                            <v-btn
                                                    color="primary"
                                                    class="pa-0 ma-0"
                                                    icon
                                                    flat
                                            >
                                                <img src="../../../public/workflows.svg" alt="" width="24">
<!--<img src="../../../public/icons/workflows.svg" style="width: 28px"/>-->
                                            </v-btn>
                                        </v-flex>
                                        <v-flex xs12 class="pl-3">
                                            <v-card
                                                    flat
                                                    class="pa-2"
                                                    ripple
                                                    style="width: 100%"
                                                    :style="{background: hover ? 'var(--hover-item-background)' : ''}"
                                            >
                                                <span v-if="selectedWorkflow == null" class="greyType--text body-2">Please Select a Workflow</span>
                                                <span v-else class="greyType--text body-2">{{selectedWorkflow.description}}</span>
                                            </v-card>
                                        </v-flex>
                                    </v-layout>
                                </v-hover>
                                <v-card width="400">
                                    <v-card-text style="padding-right: 0; margin-right: 0; padding-left: 0; margin-left: 0">
                                        <v-text-field
                                                label="Search Workflows"
                                                single-line
                                                v-model="workflowFilterString"
                                                color="primary"
                                                hide-details
                                                style="width: 100%"
                                                class="ma-0 pa-0 px-3"
                                                prepend-icon="search"
                                                ref="workflowSearch"
                                        ></v-text-field>
                                        <div style="overflow-y: auto; height: 300px" class="scroll">
                                            <v-treeview
                                                    class="pt-2 pl-2"
                                                    color="primary"
                                                    :items="filteredWorkflows"
                                                    item-children="children"
                                                    item-text="description"
                                                    item-key="key"
                                                    dense
                                                    compact
                                                    hide-details
                                                    open-on-click
                                                    :open-all="workflowFilterString != null && workflowFilterString != ''"
                                                    v-if="searchReset"
                                            >
                                                <template
                                                        slot="label"
                                                        slot-scope="prop"
                                                >
                                                    <v-layout
                                                            row
                                                            align-center
                                                            @click="typeof prop.item.assignGroups != 'undefined' ? selectWorkflow(prop.item) : ''"
                                                    >
                                                        <v-flex shrink v-if="typeof prop.item.assignGroups != 'undefined'">
                                                            <v-icon
                                                                    style="cursor: pointer"
                                                                    color="primary"
                                                                    class="pa-0 ma-0 pr-2"
                                                                    small
                                                            >
                                                                {{selectedWorkflow != null && prop.item.id == selectedWorkflow.id ? 'check_box' : 'check_box_outline_blank'}}
                                                            </v-icon>
                                                        </v-flex>
                                                        <v-flex>
                                                            <span class="body-2 greyType--text">{{ prop.item.description }}</span>
                                                        </v-flex>
                                                    </v-layout>

                                                </template>
                                            </v-treeview>
                                        </div>

                                    </v-card-text>
                                </v-card>
                            </v-menu>
                        </v-flex>
<!--Select Folder-->
                        <v-flex shrink v-if="loadingFolder" class="text-xs-center pa-2">
                            <v-progress-circular
                                    :size="40"
                                    :width="5"
                                    color="primary"
                                    indeterminate
                            ></v-progress-circular>
                        </v-flex>
                        <v-flex shrink v-if="selectedWorkflow != null && !loadingFolder">
                            <v-hover>
                                <v-layout
                                        row
                                        align-center
                                        slot-scope="{ hover }"
                                        style="cursor: pointer"
                                        @click="enableFolderChange ? showSelectFolder = true : ''"
                                >
                                    <v-flex shrink>
                                        <v-btn
                                                color="primary"
                                                class="pa-0 ma-0"
                                                icon
                                                flat
                                        >
<!--<img src="../../../public/folders.svg" alt="" width="24">-->
                                            <img src="../../../public/icons/folders.svg" style="width: 24px"/>
                                        </v-btn>
                                    </v-flex>
                                    <v-flex xs12 class="pl-3">
                                        <v-card
                                                flat
                                                class="pa-2"
                                                ripple
                                                style="width: 100%"
                                                :style="{background: hover ? 'var(--hover-item-background)' : ''}"
                                        >
                                            <span v-if="selectedFolder == null" class="greyType--text body-2">Please Select a Folder</span>
                                            <span v-else class="greyType--text body-2">{{typeof selectedFolder.id != 'undefined' && selectedFolder.id == 0 ? 'Task Folder' : selectedFolder.description}}</span>
                                        </v-card>
                                    </v-flex>
                                </v-layout>
                            </v-hover>

                            <app-folder-dlg
                                    v-if="!splitTask || (splitTask && splitData.folderType != 0)"
                                    :show-dialog="showSelectFolder"
                                    @dismiss="showSelectFolder = false"
                                    :get-task-header="getTaskHeader"
                                    :select-dlg="true"
                                    :user-info="userInfo"
                                    :folders="foldersSelect"
                                    :remove-contact-lists="true"
                                    dlg-type="allFoldersSelect"
                                    @appendFolderData="appendFolderData"
                                    v-model="selectedFolder"
                                    :filter-groups="
                                        splitTask && splitData.folderType == 1 ?
                                            (
                                                splitData.groupsWithAccess.length > 0 ? splitData.groupsWithAccess : null
                                            ) :
                                            (
                                                selectedWorkflow != null && selectedWorkflow.limitFolderGroups != null && selectedWorkflow.limitFolderGroups != '' && selectedWorkflow.limitFolderGroups != '[]' && JSON.parse(selectedWorkflow.limitFolderGroups).length > 0 ?
                                                    JSON.parse(selectedWorkflow.limitFolderGroups) :
                                                    null
                                            )"
                                    :local-data="localData"
                                    :show-sync="showSync"
                            />
                        </v-flex>
<!--Select User-->
                        <v-flex shrink class="pa-2 text-xs-center" v-if="loadingUsers && selectedFolder != null">
                            <v-progress-circular
                                    :size="40"
                                    :width="5"
                                    color="primary"
                                    indeterminate
                            ></v-progress-circular>
                        </v-flex>
                        <v-flex shrink v-if="!loadingUsers && (selectedFolder != null || (selectedWorkflow != null && selectedWorkflow.blankFolder != null && selectedWorkflow.blankFolder != '' && intToBool(selectedWorkflow.blankFolder)))" >
                            <v-menu
                                    v-model="showSelectUser" :disabled="!intToBool(this.userInfo.allowTransfer) || delegatedTask"
                                    width="400"
                                    max-height="600"
                                    :close-on-content-click="false"
                                    nudge-left="16"
                                    offset-y
                            >
                                <v-hover slot="activator">
                                    <v-layout
                                            row
                                            align-center
                                            slot-scope="{ hover }"
                                            style="cursor: pointer"
                                            @click="() => {}"
                                    >
                                        <v-flex shrink>
                                            <v-btn
                                                    color="primary"
                                                    class="pa-0 ma-0"
                                                    icon
                                                    flat
                                            >
                                                <img src="../../../public/users.svg" alt="" width="24">
<!--<img src="../../../public/icons/user.svg" style="height: 24px"/>-->
                                            </v-btn>
                                        </v-flex>
                                        <v-flex xs12 class="pl-3">
                                            <v-card
                                                    flat
                                                    class="pa-2"
                                                    ripple
                                                    style="width: 100%"
                                                    :style="{background: hover ? 'var(--hover-item-background)' : ''}"
                                            >
                                                <span v-if="selectedUser == null && usersWarning == null && !showDelegationError" class="greyType--text body-2">Please Select a User</span>
                                                <span v-if="showDelegationError" class="red--text body-2">No Delegation Users Available</span>
                                                <span v-if="usersWarning == null && selectedUser != null" class="greyType--text body-2">{{selectedUser.name}}</span>
                                                <span v-if="usersWarning != null" class="red--text body-2">{{usersWarning}}</span>
                                            </v-card>
                                        </v-flex>
                                    </v-layout>
                                </v-hover>
                                <v-card width="400">
                                    <v-card-text style="padding-right: 0; margin-right: 0; padding-left: 0; margin-left: 0">
                                        <v-text-field
                                                label="Search Users"
                                                single-line
                                                v-model="userFilterString"
                                                color="primary"
                                                hide-details
                                                style="width: 100%"
                                                class="ma-0 pa-0 px-2"
                                                prepend-icon="search"
                                                ref="userSearch"
                                        ></v-text-field>
                                        <div style="overflow-y: auto; max-height: 350px" class="scroll">
                                            <v-list dense>
                                                <template v-for="user in userFilterString == '' ? users.filter(() => true).sort((a,b) => a['name'] < b['name'] ? -1 : 1) : users.filter(obj => obj.name.toLowerCase().includes(userFilterString.toLowerCase())).sort((a,b) => a['name'] < b['name'] ? -1 : 1)">
                                                    <v-list-tile @click="selectUser(user)" style="cursor: pointer">
                                                        <v-list-tile-action class="px-1" style="min-width: auto">
                                                            <v-icon
                                                                    :color="typeof user.outOfOffice == 'undefined' ? 'primary' : (intToBool(user.outOfOffice) ? 'secondary' : 'primary')"
                                                                    class="pa-0 ma-0"
                                                            >
                                                                person
                                                            </v-icon>
                                                        </v-list-tile-action>
                                                        <v-list-tile-title >
                                                            {{ `${user.name}${typeof user.outOfOffice != 'undefined' && intToBool(user.outOfOffice) ? ' (Out of Office)' : ''}` }}
                                                        </v-list-tile-title>
                                                        <v-list-tile-action class="px-1" style="min-width: auto">
                                                            <v-icon
                                                                    color="primary"
                                                                    class="pa-0 ma-0"
                                                            >
                                                                {{selectedUser != null && selectedUser.id == user.id ? 'check_box' : 'check_box_outline_blank'}}
                                                            </v-icon>
                                                        </v-list-tile-action>
                                                    </v-list-tile>
                                                </template>
                                            </v-list>
                                        </div>

                                    </v-card-text>
                                </v-card>
                            </v-menu>
                        </v-flex>
<!--Task Title-->
                        <v-flex shrink v-if="selectedUser != null">
                            <v-hover slot="activator">
                                <v-layout
                                        row
                                        align-center
                                        slot-scope="{ hover }"
                                        style="cursor: pointer"
                                >
                                    <v-flex shrink>
                                        <v-btn
                                                color="primary"
                                                class="pa-0 ma-0"
                                                icon
                                                flat
                                        >
<!--<img src="../../../public/tasks_reg.svg" alt="" width="24">-->
                                            <img src="../../../public/icons/tasks.svg" style="width: 24px"/>
                                        </v-btn>
                                    </v-flex>
                                    <v-flex xs12 class="pl-3">
                                        <v-text-field
                                                label="Task Title"
                                                single-line
                                                v-model="taskTitle"
                                                color="primary"
                                                hide-details
                                                style="width: 100%"
                                                class="ma-0 pa-0"
                                                ref="taskTitleEdit"
                                                clearable
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>
                            </v-hover>
                        </v-flex>
                    </template>
                </v-layout>
            </v-card-text>
<!--Duplicate Task Check-->
            <div class="pa-2 text-xs-center" v-if="tasksLoading && selectedFolder != null" style="width: 100%">
                <v-progress-circular
                        :size="40"
                        :width="5"
                        color="primary"
                        indeterminate
                ></v-progress-circular>
            </div>
            <template v-if="selectedFolder != null && !tasksLoading && tasks.length > 0 && !showDelegationError" >
                <v-layout row wrap v-if="selectedWorkflow != null && selectedFolder != null && selectedWorkflow.id != null && selectedFolder.id != null">
                    <v-flex xs12 class="text-xs-center" v-if="tasksLoading">
                        <v-progress-circular
                                :size="40"
                                :width="5"
                                color="primary"
                                indeterminate
                        ></v-progress-circular>
                    </v-flex>
                    <v-flex xs12 v-else>
                        <template v-if="tasks.length > 0 && !resetTasks">
                            <v-layout row wrap class="pl-1">
                                <v-flex xs12 class="pl-1 py-2">
                                    <span class="greyType--text body-2">Similar Tasks</span>
                                </v-flex>
                                <v-flex style="overflow-y: auto; max-height: 200px" class="scroll pr-1">
                                    <template v-for="taskID in sortedSuggestedTasks">
                                        <div :key="taskID">
                                            <task-loading-container
                                                    v-if="typeof taskRef[taskID] == 'undefined' || taskRef[taskID] == false"
                                                    :task-id="taskID"
                                            />
                                            <task-container
                                                    v-else
                                                    :userInfo="userInfo"
                                                    :task="taskRef[taskID]"
                                                    :taskBar="false"
                                                    :showNav="true"
                                                    @taskNav="$emit('dismiss', true)"
                                            />
                                        </div>
                                    </template>
                                </v-flex>
                            </v-layout>
                        </template>
                    </v-flex>

                </v-layout>
                <v-divider></v-divider>
            </template>
            <v-divider></v-divider>
            <v-card-actions v-if="selectedWorkflow != null">
                <v-btn
                        flat
                        color="secondary"
                        dark
                        @click="createQuickTask = true"
                        :loading="addingTask"
                        :disabled="addingTask"
                        small
                        class="py-0 px-2 ma-0"
                >
                    <span>Create Task Shortcut</span>
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn
                        flat
                        color="secondary"
                        dark
                        @click="createTask()"
                        :loading="addingTask"
                        :disabled="addingTask"
                        v-if="selectedUser != null && selectedFolder != null && selectedWorkflow != null && taskTitle != null && taskTitle != ''"
                        small
                        class="py-0 px-2 ma-0"
                >
                    <v-icon left>add</v-icon>
                    <span>Create Task</span>
                </v-btn>
            </v-card-actions>
        </v-card>

        <app-input-dlg
                :show-dialog="createQuickTask"
                title="Create Task Shortcut"
                :cancel-button="true"
                :show-input-box="false"
                @dismiss="createQuickTask = false"
                :body-padding="false"
                v-if="createQuickTask"
        >
            <template slot="body">
                <div class="pa-2">
                    <div :class="topicClass">
                        <div :class="headingClass">
                            Task Shortcut Description:
                        </div>
                        <div :class="itemClass">
                            <v-text-field
                                    label="Description"
                                    single-line
                                    color="primary"
                                    append-outer-icon="save"
                                    hide-details
                                    style="width: 100%"
                                    class="pa-0 ma-0"
                                    ref="fieldDescription"
                                    v-model="quickTaskConfig.description"
                            ></v-text-field>
                        </div>
                    </div>
                    <div :class="topicClass">
                        <div :class="headingClass">
                            Task Shortcut Icon:
                        </div>
                        <v-menu bottom offset-y lazy v-model="qtiMenue" :close-on-content-click="false">
                            <template v-slot:activator="{ on }">
                                <div :class="itemClass" class="text-xs-center" v-on="on">
                                    <div class="text-xs-center">
                                        <v-btn
                                                large
                                                icon
                                                class="pa-0 ma-0"
                                                color="primary"
                                                flat
                                        >
                                            <v-icon large>{{quickTaskConfig.icon}}</v-icon>
                                        </v-btn>
                                    </div>
                                    <div class="text-xs-center caption greyType--text">
                                        {{quickTaskConfig.icon}}
                                    </div>
                                </div>
                            </template>

                            <v-card class="scrollable" style="max-width: 400px">
                                <div class="pa-1">
                                    <v-text-field
                                            label="Filter Icons"
                                            single-line
                                            clearable
                                            prepend-icon="search"
                                            color="primary"
                                            flat
                                            :hide-details="true"
                                            v-model="qtiFilterString"
                                            class="pa-0 ma-0"
                                    ></v-text-field>
                                </div>

                                <v-layout row wrap v-if="qtiMenue" class="scrollable" style="max-height: 300px;">
                                    <v-flex shrink
                                            v-for="viewIcon in qtiFilterString == null || qtiFilterString === '' ? icons : icons.filter(obj => obj.toLowerCase().includes(qtiFilterString.toLowerCase()))"
                                            class="text-xs-center pa-2 hover-item"
                                            :key="viewIcon"
                                            style="border-radius: 3px"
                                    >
                                            <v-icon
                                                    large
                                                    @click="quickTaskConfig.icon = viewIcon; qtiMenue = false"
                                                    style="cursor: pointer"
                                            >
                                                {{viewIcon}}
                                            </v-icon>
                                    </v-flex>
                                </v-layout>
                            </v-card>
                        </v-menu>
                    </div>
                </div>
            </template>
            <template slot="actions">
                <v-btn
                        small
                        color="secondary"
                        class="px-2 py-0 ma-0"
                        :disabled="blankString(quickTaskConfig.description) || addingQuickTask"
                        :loading="addingQuickTask"
                        @click="addQuickTask"
                >Create Task Shortcut</v-btn>

            </template>
        </app-input-dlg>

    </v-dialog>
</template>

<script>

    import {codeBaseMixin} from "../../codeBaseMixin";
    import FolderDlg from "../../Folders/FolderDlg";
    import {eventBus} from "../../main";
    import TaskLoadingContainer from "../../components/TaskContainer/TaskLoadingContainer";
    import TaskContainer from "../../components/TaskContainer/TaskContainer";
    import {arrPopulated, blankString} from "../../codeFunctions";
    import InputDlg from "../../components/General/InputDlg";
    import {DatasetBinder} from "@/Tasks/TaskView V2/components/TaskViewDetail/datasetBinder";

    export default {
        mixins: [codeBaseMixin],
        components: {
            appInputDlg: InputDlg,
            TaskContainer,
            TaskLoadingContainer,
            appFolderDlg: FolderDlg,
        },
        props: {
            showDialog:         {type: Boolean, default: false},
            userInfo:           Object,

            mailDBID:           {type: Number, default: null},
            mailID:             {type: String, default: null},
            mail:               {type: [Object, Array], default: null},
            splitData:          {type: Object, default: null},
            task:               {type: Object, default: null},

            splitTask:          {type: Boolean, default: false},
            mailTask:           {type: Boolean, default: false},
            mailBoxTask:        {type: Boolean, default: false},
            folderGroups:       Array,
            mailType:           {type: String, default: 'Gmail'},

            localData:          Object,
            showSync:           Boolean,
            getTaskHeader:      Function,
            quickTask:          Object,
            binder:             DatasetBinder
        },
        data() {
            return {
                loadingWorkflows: false,
                workflows: [],
                selectedWorkflow: null,
                workflowFilterString: "",
                searchReset: true,
                showSelectWorkflow: false,

                selectedFolder: null,
                showSelectFolder: false,
                foldersSelect: {
                    folderGroups: [],
                    folders: []
                },
                enableFolderChange: true,
                loadingFolder: false,

                selectedUser: null,
                loadingUsers: false,
                usersWarning: null,
                delegatedTask: false,
                users: [],
                showSelectUser: false,
                userFilterString: "",

                taskTitle: "",

                addingTask: false,
                tasks: [],
                tasksLoading: false,
                selectedTaskID: 0,
                showDelegationError: false,
                taskRef: [],
                resetTasks: false,
                showCreateQuickTask: false,
                createQuickTask: false,
                quickTaskConfig: {
                    workflow: null,
                    folder: null,
                    description: null,
                    icon: null
                },
                icons: ['3d_rotation', 'ac_unit', 'access_alarm', 'access_alarms', 'access_time', 'accessibility', 'accessible', 'account_balance', 'account_balance_wallet', 'account_box', 'account_circle', 'adb', 'add', 'add_a_photo', 'add_alarm', 'add_alert', 'add_box', 'add_circle', 'add_circle_outline', 'add_location', 'add_shopping_cart', 'add_to_photos', 'add_to_queue', 'adjust', 'airline_seat_flat', 'airline_seat_flat_angled', 'airline_seat_individual_suite', 'airline_seat_legroom_extra', 'airline_seat_legroom_normal', 'airline_seat_legroom_reduced', 'airline_seat_recline_extra', 'airline_seat_recline_normal', 'airplanemode_active', 'airplanemode_inactive', 'airplay', 'airport_shuttle', 'alarm', 'alarm_add', 'alarm_off', 'alarm_on', 'album', 'all_inclusive', 'all_out', 'android', 'announcement', 'apps', 'archive', 'arrow_back', 'arrow_downward', 'arrow_drop_down', 'arrow_drop_down_circle', 'arrow_drop_up', 'arrow_forward', 'arrow_upward', 'art_track', 'aspect_ratio', 'assessment', 'assignment', 'assignment_ind', 'assignment_late', 'assignment_return', 'assignment_returned', 'assignment_turned_in', 'assistant', 'assistant_photo', 'attach_file', 'attach_money', 'attachment', 'audiotrack', 'autorenew', 'av_timer', 'backspace', 'backup', 'battery_alert', 'battery_charging_full', 'battery_full', 'battery_std', 'battery_unknown', 'beach_access', 'beenhere', 'block', 'bluetooth', 'bluetooth_audio', 'bluetooth_connected', 'bluetooth_disabled', 'bluetooth_searching', 'blur_circular', 'blur_linear', 'blur_off', 'blur_on', 'book', 'bookmark', 'bookmark_border', 'border_all', 'border_bottom', 'border_clear', 'border_color', 'border_horizontal', 'border_inner', 'border_left', 'border_outer', 'border_right', 'border_style', 'border_top', 'border_vertical', 'branding_watermark', 'brightness_1', 'brightness_2', 'brightness_3', 'brightness_4', 'brightness_5', 'brightness_6', 'brightness_7', 'brightness_auto', 'brightness_high', 'brightness_low', 'brightness_medium', 'broken_image', 'brush', 'bubble_chart', 'bug_report', 'build', 'burst_mode', 'business', 'business_center', 'cached', 'cake', 'call', 'call_end', 'call_made', 'call_merge', 'call_missed', 'call_missed_outgoing', 'call_received', 'call_split', 'call_to_action', 'camera', 'camera_alt', 'camera_enhance', 'camera_front', 'camera_rear', 'camera_roll', 'cancel', 'card_giftcard', 'card_membership', 'card_travel', 'casino', 'cast', 'cast_connected', 'center_focus_strong', 'center_focus_weak', 'change_history', 'chat', 'chat_bubble', 'chat_bubble_outline', 'check', 'check_box', 'check_box_outline_blank', 'check_circle', 'chevron_left', 'chevron_right', 'child_care', 'child_friendly', 'chrome_reader_mode', 'class', 'clear', 'clear_all', 'close', 'closed_caption', 'cloud', 'cloud_circle', 'cloud_done', 'cloud_download', 'cloud_off', 'cloud_queue', 'cloud_upload', 'code', 'collections', 'collections_bookmark', 'color_lens', 'colorize', 'comment', 'compare', 'compare_arrows', 'computer', 'confirmation_number', 'contact_mail', 'contact_phone', 'contacts', 'content_copy', 'content_cut', 'content_paste', 'control_point', 'control_point_duplicate', 'copyright', 'create', 'create_new_folder', 'credit_card', 'crop', 'crop_16_9', 'crop_3_2', 'crop_5_4', 'crop_7_5', 'crop_din', 'crop_free', 'crop_landscape', 'crop_original', 'crop_portrait', 'crop_rotate', 'crop_square', 'dashboard', 'data_usage', 'date_range', 'dehaze', 'delete', 'delete_forever', 'delete_sweep', 'description', 'desktop_mac', 'desktop_windows', 'details', 'developer_board', 'developer_mode', 'device_hub', 'devices', 'devices_other', 'dialer_sip', 'dialpad', 'directions', 'directions_bike', 'directions_boat', 'directions_bus', 'directions_car', 'directions_railway', 'directions_run', 'directions_subway', 'directions_transit', 'directions_walk', 'disc_full', 'dns', 'do_not_disturb', 'do_not_disturb_alt', 'do_not_disturb_off', 'do_not_disturb_on', 'dock', 'domain', 'done', 'done_all', 'donut_large', 'donut_small', 'drafts', 'drag_handle', 'drive_eta', 'dvr', 'edit', 'edit_location', 'eject', 'email', 'enhanced_encryption', 'equalizer', 'error', 'error_outline', 'euro_symbol', 'ev_station', 'event', 'event_available', 'event_busy', 'event_note', 'event_seat', 'exit_to_app', 'expand_less', 'expand_more', 'explicit', 'explore', 'exposure', 'exposure_neg_1', 'exposure_neg_2', 'exposure_plus_1', 'exposure_plus_2', 'exposure_zero', 'extension', 'face', 'fast_forward', 'fast_rewind', 'favorite', 'favorite_border', 'featured_play_list', 'featured_video', 'feedback', 'fiber_dvr', 'fiber_manual_record', 'fiber_new', 'fiber_pin', 'fiber_smart_record', 'file_download', 'file_upload', 'filter', 'filter_1', 'filter_2', 'filter_3', 'filter_4', 'filter_5', 'filter_6', 'filter_7', 'filter_8', 'filter_9', 'filter_9_plus', 'filter_b_and_w', 'filter_center_focus', 'filter_drama', 'filter_frames', 'filter_hdr', 'filter_list', 'filter_none', 'filter_tilt_shift', 'filter_vintage', 'find_in_page', 'find_replace', 'fingerprint', 'first_page', 'fitness_center', 'flag', 'flare', 'flash_auto', 'flash_off', 'flash_on', 'flight', 'flight_land', 'flight_takeoff', 'flip', 'flip_to_back', 'flip_to_front', 'folder', 'folder_open', 'folder_shared', 'folder_special', 'font_download', 'format_align_center', 'format_align_justify', 'format_align_left', 'format_align_right', 'format_bold', 'format_clear', 'format_color_fill', 'format_color_reset', 'format_color_text', 'format_indent_decrease', 'format_indent_increase', 'format_italic', 'format_line_spacing', 'format_list_bulleted', 'format_list_numbered', 'format_paint', 'format_quote', 'format_shapes', 'format_size', 'format_strikethrough', 'format_textdirection_l_to_r', 'format_textdirection_r_to_l', 'format_underlined', 'forum', 'forward', 'forward_10', 'forward_30', 'forward_5', 'free_breakfast', 'fullscreen', 'fullscreen_exit', 'functions', 'g_translate', 'gamepad', 'games', 'gavel', 'gesture', 'get_app', 'gif', 'golf_course', 'gps_fixed', 'gps_not_fixed', 'gps_off', 'grade', 'gradient', 'grain', 'graphic_eq', 'grid_off', 'grid_on', 'group', 'group_add', 'group_work', 'hd', 'hdr_off', 'hdr_on', 'hdr_strong', 'hdr_weak', 'headset', 'headset_mic', 'healing', 'hearing', 'help', 'help_outline', 'high_quality', 'highlight', 'highlight_off', 'history', 'home', 'hot_tub', 'hotel', 'hourglass_empty', 'hourglass_full', 'http', 'https', 'image', 'image_aspect_ratio', 'import_contacts', 'import_export', 'important_devices', 'inbox', 'indeterminate_check_box', 'info', 'info_outline', 'input', 'insert_chart', 'insert_comment', 'insert_drive_file', 'insert_emoticon', 'insert_invitation', 'insert_link', 'insert_photo', 'invert_colors', 'invert_colors_off', 'iso', 'keyboard', 'keyboard_arrow_down', 'keyboard_arrow_left', 'keyboard_arrow_right', 'keyboard_arrow_up', 'keyboard_backspace', 'keyboard_capslock', 'keyboard_hide', 'keyboard_return', 'keyboard_tab', 'keyboard_voice', 'kitchen', 'label', 'label_outline', 'landscape', 'language', 'laptop', 'laptop_chromebook', 'laptop_mac', 'laptop_windows', 'last_page', 'launch', 'layers', 'layers_clear', 'leak_add', 'leak_remove', 'lens', 'library_add', 'library_books', 'library_music', 'lightbulb_outline', 'line_style', 'line_weight', 'linear_scale', 'link', 'linked_camera', 'list', 'live_help', 'live_tv', 'local_activity', 'local_airport', 'local_atm', 'local_bar', 'local_cafe', 'local_car_wash', 'local_convenience_store', 'local_dining', 'local_drink', 'local_florist', 'local_gas_station', 'local_grocery_store', 'local_hospital', 'local_hotel', 'local_laundry_service', 'local_library', 'local_mall', 'local_movies', 'local_offer', 'local_parking', 'local_pharmacy', 'local_phone', 'local_pizza', 'local_play', 'local_post_office', 'local_printshop', 'local_see', 'local_shipping', 'local_taxi', 'location_city', 'location_disabled', 'location_off', 'location_on', 'location_searching', 'lock', 'lock_open', 'lock_outline', 'looks', 'looks_3', 'looks_4', 'looks_5', 'looks_6', 'looks_one', 'looks_two', 'loop', 'loupe', 'low_priority', 'loyalty', 'mail', 'mail_outline', 'map', 'markunread', 'markunread_mailbox', 'memory', 'menu', 'merge_type', 'message', 'mic', 'mic_none', 'mic_off', 'mms', 'mode_comment', 'mode_edit', 'monetization_on', 'money_off', 'monochrome_photos', 'mood', 'mood_bad', 'more', 'more_horiz', 'more_vert', 'motorcycle', 'mouse', 'move_to_inbox', 'movie', 'movie_creation', 'movie_filter', 'multiline_chart', 'music_note', 'music_video', 'my_location', 'nature', 'nature_people', 'navigate_before', 'navigate_next', 'navigation', 'near_me', 'network_cell', 'network_check', 'network_locked', 'network_wifi', 'new_releases', 'next_week', 'nfc', 'no_encryption', 'no_sim', 'not_interested', 'note', 'note_add', 'notifications', 'notifications_active', 'notifications_none', 'notifications_off', 'notifications_paused', 'offline_pin', 'ondemand_video', 'opacity', 'open_in_browser', 'open_in_new', 'open_with', 'pages', 'pageview', 'palette', 'pan_tool', 'panorama', 'panorama_fish_eye', 'panorama_horizontal', 'panorama_vertical', 'panorama_wide_angle', 'party_mode', 'pause', 'pause_circle_filled', 'pause_circle_outline', 'payment', 'people', 'people_outline', 'perm_camera_mic', 'perm_contact_calendar', 'perm_data_setting', 'perm_device_information', 'perm_identity', 'perm_media', 'perm_phone_msg', 'perm_scan_wifi', 'person', 'person_add', 'person_outline', 'person_pin', 'person_pin_circle', 'personal_video', 'pets', 'phone', 'phone_android', 'phone_bluetooth_speaker', 'phone_forwarded', 'phone_in_talk', 'phone_iphone', 'phone_locked', 'phone_missed', 'phone_paused', 'phonelink', 'phonelink_erase', 'phonelink_lock', 'phonelink_off', 'phonelink_ring', 'phonelink_setup', 'photo', 'photo_album', 'photo_camera', 'photo_filter', 'photo_library', 'photo_size_select_actual', 'photo_size_select_large', 'photo_size_select_small', 'picture_as_pdf', 'picture_in_picture', 'picture_in_picture_alt', 'pie_chart', 'pie_chart_outlined', 'pin_drop', 'place', 'play_arrow', 'play_circle_filled', 'play_circle_outline', 'play_for_work', 'playlist_add', 'playlist_add_check', 'playlist_play', 'plus_one', 'poll', 'polymer', 'pool', 'portable_wifi_off', 'portrait', 'power', 'power_input', 'power_settings_new', 'pregnant_woman', 'present_to_all', 'print', 'priority_high', 'public', 'publish', 'query_builder', 'question_answer', 'queue', 'queue_music', 'queue_play_next', 'radio', 'radio_button_checked', 'radio_button_unchecked', 'rate_review', 'receipt', 'recent_actors', 'record_voice_over', 'redeem', 'redo', 'refresh', 'remove', 'remove_circle', 'remove_circle_outline', 'remove_from_queue', 'remove_red_eye', 'remove_shopping_cart', 'reorder', 'repeat', 'repeat_one', 'replay', 'replay_10', 'replay_30', 'replay_5', 'reply', 'reply_all', 'report', 'report_problem', 'restaurant', 'restaurant_menu', 'restore', 'restore_page', 'ring_volume', 'room', 'room_service', 'rotate_90_degrees_ccw', 'rotate_left', 'rotate_right', 'rounded_corner', 'router', 'rowing', 'rss_feed', 'rv_hookup', 'satellite', 'save', 'scanner', 'schedule', 'school', 'screen_lock_landscape', 'screen_lock_portrait', 'screen_lock_rotation', 'screen_rotation', 'screen_share', 'sd_card', 'sd_storage', 'search', 'security', 'select_all', 'send', 'sentiment_dissatisfied', 'sentiment_neutral', 'sentiment_satisfied', 'sentiment_very_dissatisfied', 'sentiment_very_satisfied', 'settings', 'settings_applications', 'settings_backup_restore', 'settings_bluetooth', 'settings_brightness', 'settings_cell', 'settings_ethernet', 'settings_input_antenna', 'settings_input_component', 'settings_input_composite', 'settings_input_hdmi', 'settings_input_svideo', 'settings_overscan', 'settings_phone', 'settings_power', 'settings_remote', 'settings_system_daydream', 'settings_voice', 'share', 'shop', 'shop_two', 'shopping_basket', 'shopping_cart', 'short_text', 'show_chart', 'shuffle', 'signal_cellular_4_bar', 'signal_cellular_connected_no_internet_4_bar', 'signal_cellular_no_sim', 'signal_cellular_null', 'signal_cellular_off', 'signal_wifi_4_bar', 'signal_wifi_4_bar_lock', 'signal_wifi_off', 'sim_card', 'sim_card_alert', 'skip_next', 'skip_previous', 'slideshow', 'slow_motion_video', 'smartphone', 'smoke_free', 'smoking_rooms', 'sms', 'sms_failed', 'snooze', 'sort', 'sort_by_alpha', 'spa', 'space_bar', 'speaker', 'speaker_group', 'speaker_notes', 'speaker_notes_off', 'speaker_phone', 'spellcheck', 'star', 'star_border', 'star_half', 'stars', 'stay_current_landscape', 'stay_current_portrait', 'stay_primary_landscape', 'stay_primary_portrait', 'stop', 'stop_screen_share', 'storage', 'store', 'store_mall_directory', 'straighten', 'streetview', 'strikethrough_s', 'style', 'subdirectory_arrow_left', 'subdirectory_arrow_right', 'subject', 'subscriptions', 'subtitles', 'subway', 'supervisor_account', 'surround_sound', 'swap_calls', 'swap_horiz', 'swap_vert', 'swap_vertical_circle', 'switch_camera', 'switch_video', 'sync', 'sync_disabled', 'sync_problem', 'system_update', 'system_update_alt', 'tab', 'tab_unselected', 'tablet', 'tablet_android', 'tablet_mac', 'tag_faces', 'tap_and_play', 'terrain', 'text_fields', 'text_format', 'textsms', 'texture', 'theaters', 'thumb_down', 'thumb_up', 'thumbs_up_down', 'time_to_leave', 'timelapse', 'timeline', 'timer', 'timer_10', 'timer_3', 'timer_off', 'title', 'toc', 'today', 'toll', 'tonality', 'touch_app', 'toys', 'track_changes', 'traffic', 'train', 'tram', 'transfer_within_a_station', 'transform', 'translate', 'trending_down', 'trending_flat', 'trending_up', 'tune', 'turned_in', 'turned_in_not', 'tv', 'unarchive', 'undo', 'unfold_less', 'unfold_more', 'update', 'usb', 'verified_user', 'vertical_align_bottom', 'vertical_align_center', 'vertical_align_top', 'vibration', 'video_call', 'video_label', 'video_library', 'videocam', 'videocam_off', 'videogame_asset', 'view_agenda', 'view_array', 'view_carousel', 'view_column', 'view_comfy', 'view_compact', 'view_day', 'view_headline', 'view_list', 'view_module', 'view_quilt', 'view_stream', 'view_week', 'vignette', 'visibility', 'visibility_off', 'voice_chat', 'voicemail', 'volume_down', 'volume_mute', 'volume_off', 'volume_up', 'vpn_key', 'vpn_lock', 'wallpaper', 'warning', 'watch', 'watch_later', 'wb_auto', 'wb_cloudy', 'wb_incandescent', 'wb_iridescent', 'wb_sunny', 'wc', 'web', 'web_asset', 'weekend', 'whatshot', 'widgets', 'wifi', 'wifi_lock', 'wifi_tethering', 'work', 'wrap_text', 'youtube_searched_for', 'zoom_in', 'zoom_out', 'zoom_out_map'],
                addingQuickTask: false,
                qtiMenue: false,
                qtiFilterString: null
            }
        },
        watch: {
            showDialog(shown) {
                if (shown) {
                    this.loadingWorkflows = false;
                    this.workflows = [];
                    this.selectedWorkflow = null;
                    this.workflowFilterString = "";
                    this.searchReset = true;
                    this.showSelectWorkflow = false;
                    this.selectedFolder = null;
                    this.showSelectFolder = false;
                    this.foldersSelect = {folderGroups: [],folders: []};
                    this.enableFolderChange = true;
                    this.loadingFolder = false;
                    this.selectedUser = null;
                    this.loadingUsers = false;
                    this.usersWarning = null;
                    this.delegatedTask = false;
                    this.users = [];
                    this.showSelectUser = false;
                    this.userFilterString = "";
                    this.taskTitle = "";
                    this.addingTask = false;
                    this.tasks = [];
                    this.tasksLoading = false;
                    this.selectedTaskID = 0;
                    this.showDelegationError = false;

                    if (this.splitTask) {
                        // Split Task
                        if (
                            this.splitData != null
                            && typeof this.splitData.workflowID != "undefined"
                            && this.splitData.workflowID != null
                            && typeof this.splitData.workflowID.id != "undefined"
                            && this.splitData.workflowID.id != null
                        ) {
                            this.initiateSplit(this.splitData.workflowID.id)


                            if (this.splitData.folderType == 2) {
                                this.enableFolderChange = false;
                                this.getFolderDetail(this.splitData.folder);
                            }

                            if (this.splitData.folderType == 3) {
                                this.enableFolderChange = false;
                                this.getFolderDetail(this.binder.folderSelectFieldFolderRef[this.splitData.folderSelectField]);
                            }

                            if (this.splitData.folderType == 0) {
                                this.enableFolderChange = false;
                                this.getFolderDetail(this.task.folderID);
                            }

                        } else {
                            this.showSnack('Error', 'Invalid Split Task Configuration', 'Close', 'red')
                        }
                    } else {
                        //Regular Task, Mail Task
                        this.initiate();
                    }

                    if (typeof this.quickTask !== 'undefined' && this.quickTask !== null) {
                        this.initiateQuick(this.quickTask.workflow, this.quickTask.folder)
                        this.$emit('clearQuick')
                    }
                }
            },
            workflowFilterString() {
                this.searchReset = false;
                this.$nextTick(() => {
                    this.searchReset = true;
                })
            },
            showSelectWorkflow(shown) {
                if (shown) {
                    setTimeout(() => {
                        this.$nextTick(() => {
                            this.$refs.workflowSearch.focus();
                        });
                    }, 200)
                }
            },
            showSelectUser(shown) {
                if (shown) {
                    setTimeout(() => {
                        this.$nextTick(() => {
                            this.$refs.userSearch.focus();
                        });
                    }, 200)
                }
            },
            loadUsers() {},
            tasks: {
                deep:true,
                handler(val) {
                    if (Array.isArray(val) && val.length > 0) {
                        val.forEach(task => {
                            this.taskRef[task] = false;
                            this.getTaskHeader(task)
                            .then((fullTask) => {

                                this.taskRef[task] = fullTask
                                this.resetTasks = true;
                                this.$nextTick(() => {
                                    this.resetTasks = false;
                                })
                            })
                            .catch(err => {console.log(err)})
                        })
                    }
                }
            },
            qtiMenue(val) {
                if (val) {this.qtiFilterString = null}
            },
            createQuickTask(val) {
                if (val) {
                    this.quickTaskConfig = {
                        workflow: this.selectedWorkflow.id,
                        folder: this.selectedFolder != null && this.selectedFolder.id > 0 ? this.selectedFolder.id : -1,
                        description: null,
                        icon: 'done_all'
                    }
                }
            }
        },
        methods: {
            addQuickTask() {
                this.quickTaskConfig.order = this.userInfo.quickTasks.length;
                this.addingQuickTask = true;
                this.fetch({method: 'POST', url:`/tasks/quickTask/add/new/${this.userInfo.entityID}/${this.userInfo.userID}`, body: JSON.stringify(this.quickTaskConfig)})
                    .then((data) => {
                        this.userInfo.quickTasks.push(data);
                        this.addingQuickTask = false;
                        this.createQuickTask = false;
                        this.$emit('dismiss');
                        this.showSnack('Info', 'Task Shortcut Added', 'Close', 'primary')
                    })
                    .catch((e) => {
                        // eslint-disable-next-line
                        console.log(e);
                        this.showSnack('Error', 'Network error. Please try again.', 'Close', 'red');
                        this.addingQuickTask = false;
                    })
            },
            initiateQuick(workflowID, folderID) {

                folderID = folderID || -1;

                this.loadingWorkflows = true;
                this.workflows = [];
                this.fetch({method: 'GET', url:`/tasks/newQuickTask/${this.userInfo.entityID}/${this.userInfo.userID}/${workflowID}`})
                    .then((data) => {
                        if (data.workflowAccess === 1) {
                            this.selectWorkflow(data);
                            this.loadingWorkflows = false;

                            if (folderID >= 0) {

                                let tFolder = this.localData.folders.filter(obj => obj.id === folderID).pop();

                                // Check Access To Folder
                                if (!tFolder.access) {
                                    this.showSnack('Error', 'Access Denied To Folder', 'Close', 'red')
                                    return;
                                }

                                // Check Folder Limit
                                let folderLimit = JSON.parse(blankString(data.limitFolderGroups) ? '[]' : data.limitFolderGroups);
                                if (arrPopulated(folderLimit)) {
                                    // Limited So Check Folders Folder Groups
                                    if (!(tFolder.folderGroups.filter(obj => folderLimit.includes(obj)).length > 0)) {
                                        //Folder Is NOT In The Limit
                                        this.showSnack('Error', 'Workflow limited folder groups criteria not met', 'Close', 'red');
                                        return;
                                    }
                                }

                                this.selectedFolder = tFolder;
                            }

                        } else {
                            this.showSnack('Error', 'Access Denied To Workflow', 'Close', 'red')
                            this.loadingWorkflows = false;
                        }

                        // this.getFolderDetail(11)
                    })
                    .catch((e) => {
                        // eslint-disable-next-line
                        console.log(e);
                        this.showSnack('Error', 'Network error. Please try again.', 'Close', 'red');
                        this.loadingWorkflows = false;
                    })
            },
            updateTitle(newTitle) {
                this.taskTitle = newTitle
            },
            selectUser(user) {
                this.selectedUser = user;
                this.showSelectUser = false;
                setTimeout(() => {
                    this.$nextTick(() => {
                        this.$refs.taskTitleEdit.focus();
                    });
                }, 200)
            },
            appendFolderData(data) {
                this.foldersSelect = data
            },
            selectWorkflow(workflow) {
                this.selectedWorkflow = workflow;
                this.showSelectWorkflow = false;
                this.showDelegationError = false;
                if (this.intToBool(this.selectedWorkflow.blankFolder)) {
                    this.selectedFolder = {id: 0, name: "Task Folder"};
                }
            },
            initiate() {
                this.loadingWorkflows = true;
                this.workflows = [];

                this.fetch({method: 'GET', url:`/tasks/newTaskData/${this.userInfo.entityID}/${this.userInfo.userID}`})
                    .then((data) => {
                        this.workflows = data.map(obj => {obj.children = JSON.parse(obj.children); return obj});
                        this.loadingWorkflows = false;
                    })
                    .catch((e) => {
                        // eslint-disable-next-line
                        console.log(e)
                        this.showSnack('Error', 'Network error. Please try again.', 'Close', 'red');
                        this.loadingWorkflows = false;
                    })
            },
            initiateSplit(workflowID) {
                this.loadingWorkflows = true;
                this.workflows = [];
                this.fetch({method: 'GET', url:`/tasks/newTaskDataSplit/${this.userInfo.entityID}/${workflowID}`})
                    .then((data) => {
                        if (this.splitData.folderType == 1) {
                            this.selectWorkflow(data);
                        } else {
                            this.selectedWorkflow = data;
                        }
                        this.loadingWorkflows = false;
                    })
                    .catch((e) => {
                        // eslint-disable-next-line
                        console.log(e);
                        this.showSnack('Error', 'Network error. Please try again.', 'Close', 'red');
                        this.loadingWorkflows = false;
                    })
            },
            getFolderDetail(folderID) {
                // this.loadingFolder = true;
                this.workflows = [];

                this.selectedFolder = this.localData.folders.filter(obj => obj.id === folderID).pop();

                this.loadingFolder = false;
                // this.fetch({method: 'GET', url:`/tasks/newTaskDataSplitFolder/${this.userInfo.entityID}/${folderID}`})
                //     .then((data) => {
                //         this.selectedFolder = data;
                //         this.loadingFolder = false;
                //     })
                //     .catch((e) => {
                //         // eslint-disable-next-line
                //         console.log(e);
                //         this.showSnack('Error', 'Network error. Please try again.', 'Close', 'red');
                //         this.loadingFolder = false;
                //     })
            },
            loadUsersSplit() {
                this.showDelegationError = false;
                this.delegatedTask = false;
                this.selectedUser = null;
                // Check If Workflow Has Assign Groups
                if (
                    this.selectedWorkflow != null
                    && typeof this.selectedWorkflow.assignGroups != 'undefined'
                    && this.selectedWorkflow.assignGroups != null
                    && this.selectedWorkflow.assignGroups != ''
                    && this.selectedWorkflow.assignGroups != '[]'
                    && JSON.parse(this.selectedWorkflow.assignGroups).length > 0
                ) {
                    if (JSON.parse(this.selectedWorkflow.assignGroups).filter(element => this.userInfo.userGroups.includes(element)).length > 0) {
                        this.delegatedTask = true;
                    }
                }

                if (this.delegatedTask) {
                    this.loadDelegateUser()
                } else {
                    if (this.intToBool(this.userInfo.allowTransfer)) {
                        this.loadUsersWithAccess()
                    } else {
                        // Resume Here
                        this.checkUsersWithAccess()
                    }
                }
            },
            loadUsersWithAccess() {
                if (!this.intToBool(this.selectedWorkflow.allowShare)) {
                    // Resume here
                    this.loadingUsers = true;
                    this.users = [];
                    this.fetch({method: 'GET', url:`/tasks/newTaskAuthorizedUsers/${this.userInfo.entityID}/${this.selectedFolder.id}/${this.selectedWorkflow.id}`})
                        .then((data) => {
                            this.users = data;
                            this.loadingUsers = false;

                            if (data.filter(obj => obj.id == this.userInfo.userID).length > 0) {
                                this.selectedUser = {id: this.userInfo.userID, name: `${this.userInfo.name} ${this.userInfo.surname}`}
                                setTimeout(() => {
                                    this.$nextTick(() => {
                                        this.$refs.taskTitleEdit.focus();
                                    });
                                }, 200)
                            }
                        })
                        .catch((e) => {
                            // eslint-disable-next-line
                            console.log(e);
                            this.showSnack('Error', 'Network error. Please try again.', 'Close', 'red');
                            this.loadingUsers = false;
                        })
                } else {
                    this.loadingUsers = true;
                    this.users = [];
                    this.fetch({method: 'GET', url:`/tasks/newTaskAllUsersWithWorkflowAccess/${this.userInfo.entityID}/${this.selectedWorkflow.id}`})
                        .then((data) => {
                            this.users = data;
                            this.loadingUsers = false;
                            this.selectedUser = {id: this.userInfo.userID, name: `${this.userInfo.name} ${this.userInfo.surname}`}
                            setTimeout(() => {
                                this.$nextTick(() => {
                                    this.$refs.taskTitleEdit.focus();
                                });
                            }, 200)

                        })
                        .catch((e) => {
                            // eslint-disable-next-line
                            console.log(e);
                            this.showSnack('Error', 'Network error. Please try again.', 'Close', 'red');
                            this.loadingUsers = false;
                        })
                }
            },
            checkUsersWithAccess() {
                if (this.selectedFolder.id != 0) {
                    this.loadingUsers = true;
                    this.users = [];
                    this.fetch({method: 'GET', url:`/tasks/newTaskAuthorizedUsers/${this.userInfo.entityID}/${this.selectedFolder.id}/${this.selectedWorkflow.id}`})
                        .then((data) => {
                            if (data.filter(obj => obj.id == this.userInfo.userID).length > 0) {
                                this.selectedUser = {id: this.userInfo.userID, name: `${this.userInfo.name} ${this.userInfo.surname}`}
                                setTimeout(() => {
                                    this.$nextTick(() => {
                                        this.$refs.taskTitleEdit.focus();
                                    });
                                }, 200)
                            } else {
                                this.usersWarning = 'Can Not Assign A User'
                            }
                            this.loadingUsers = false;
                        })
                        .catch((e) => {
                            // eslint-disable-next-line
                            console.log(e);
                            this.showSnack('Error', 'Network error. Please try again.', 'Close', 'red');
                            this.loadingUsers = false;
                        })
                } else {
                    // No Transfer Select Current User
                    this.selectedUser = {id: this.userInfo.userID, name: `${this.userInfo.name} ${this.userInfo.surname}`};
                    setTimeout(() => {
                        this.$nextTick(() => {
                            this.$refs.taskTitleEdit.focus();
                        });
                    }, 200);
                }
            },
            loadDelegateUser() {
                if (
                    this.selectedWorkflow != null
                    && typeof this.selectedWorkflow.delegationGroups != 'undefined'
                    && this.selectedWorkflow.delegationGroups != null
                    && this.selectedWorkflow.delegationGroups != ''
                    && this.selectedWorkflow.delegationGroups != '[]'
                    && JSON.parse(this.selectedWorkflow.delegationGroups).length > 0
                ) {
                    this.loadingUsers = true;
                    this.users = [];
                    this.fetch({method: 'PATCH', url:`/tasks/newTaskDelegateUser/${this.userInfo.entityID}/${this.selectedFolder.id}/${this.selectedWorkflow.id}`, body: JSON.stringify({delegationGroups: this.selectedWorkflow.delegationGroups})})
                        .then((data) => {
                            if (data != '') {
                                this.selectedUser = data;
                                this.loadingUsers = false;
                                setTimeout(() => {
                                    this.$nextTick(() => {
                                        this.$refs.taskTitleEdit.focus();
                                    });
                                }, 200)
                            } else {
                                this.selectedUser = null;
                                this.loadingUsers = false;
                                this.showDelegationError = true;
                            }
                        })
                        .catch((e) => {
                            // eslint-disable-next-line
                            console.log(e);
                            this.showSnack('Error', 'Network error. Please try again.', 'Close', 'red');
                            this.loadingUsers = false;
                        })
                } else {
                    this.showSnack('Error', 'Invalid Delegation Setting', 'Close', 'red');
                    this.loadingUsers = false;
                }
            },
            createTask() {
                if (!this.splitTask && !this.mailTask && !this.mailBoxTask) {this.createTaskRegular();}
                if (this.splitTask) {this.createTaskSplitTask();}
                if (this.mailTask) {

                    switch (this.mailType) {
                        case 'Office': {
                            this.createTaskOfficeMail();
                            break;
                        }
                        case 'SMTP': {
                            this.createTaskSMTPMail();
                            break;
                        }
                        case 'MAILBOX': {
                            this.createTaskSMTPMailbox();
                            break;
                        }
                      case 'ZOHO': {
                        this.createTaskZohoMail();
                        break;
                      }
                        default: {
                            this.createTaskGmailMail();
                        }

                    }
                }
                if (this.mailBoxTask) {this.createTaskGroupMailbox();}
            },
            createTaskRegular() {

                this.addingTask = true;

                let jBody = {
                    workflow: this.selectedWorkflow.id,
                    user: this.selectedUser.id,
                    folder: this.selectedFolder.id,
                    title: this.taskTitle
                };

                this.fetch({method: 'POST', url:`/tasks/${this.userInfo.entityID}/${this.userInfo.userID}`, body: JSON.stringify(jBody)})
                    .then((data) => {
                        this.getTaskHeader(data.taskID)
                        .then(task => {
                            task.structure = {};
                            task.structure.steps = [];
                            task.structure.mails = [];
                            task.structure.fields = [];
                            task.structure.draftMails = [];
                            task.structure.draftNotes = [];
                            eventBus.$emit('taskCreated', task);
                            this.$emit('dismiss');
                            this.addingTask = false;
                        })
                        .catch(err => {console.log(err)})
                    })
                    .catch((e) => {
                        // eslint-disable-next-line
                        console.log(e)
                        this.showSnack('Error', 'Network error. Please try again.', 'Close', 'red');
                        this.addingTask = false;
                    })

            },
            createTaskGmailMail() {

                this.addingTask = true;

                let jBody = {
                    workflow: this.selectedWorkflow.id,
                    user: this.selectedUser.id,
                    folder: this.selectedFolder.id,
                    title: this.taskTitle,
                    mail: this.mail
                };

                this.fetch({method: 'PATCH', url:`/gmail/msg/createAndLinkMailToTask/${this.userInfo.entityID}/${this.userInfo.userID}`, body: JSON.stringify(jBody)})
                    .then((data) => {

                        this.getTaskHeader(data.taskID)
                            .then(task => {
                                task.structure = {};
                                task.structure.steps = [];
                                task.structure.mails = [];
                                task.structure.fields = [];
                                task.structure.draftMails = [];
                                task.structure.draftNotes = [];

                                this.$emit('pushTask', task);
                                eventBus.$emit('snackCreateTask', task);
                                eventBus.$emit('mailLinkedToTask', {mail: this.mail, task: task});
                                this.addingTask = false;
                                this.$emit('dismiss');
                            })
                            .catch(err => {console.log(err)})
                    })
                    .catch((e) => {
                        // eslint-disable-next-line
                        console.log(e)
                        this.showSnack('Error', 'Network error. Please try again.', 'Close', 'red')
                        this.addingTask = false;
                    })

            },
            createTaskSMTPMail() {
                this.addingTask = true;

                let jBody = {
                    workflow: this.selectedWorkflow.id,
                    user: this.selectedUser.id,
                    folder: this.selectedFolder.id,
                    title: this.taskTitle,
                    mail: this.mail
                };

                this.fetch({method: 'POST', url:`/SMTP/createAndLinkMailToTask/${this.userInfo.entityID}/${this.userInfo.userID}`, body: JSON.stringify(jBody)})
                    .then((data) => {

                        this.getTaskHeader(data.taskID)
                            .then((task) => {
                                task.structure = {};
                                task.structure.steps = [];
                                task.structure.mails = [];
                                task.structure.fields = [];
                                task.structure.draftMails = [];
                                task.structure.draftNotes = [];

                                this.$emit('pushTask', task);
                                eventBus.$emit('snackCreateTask', task);
                                this.addingTask = false;
                                this.$emit('dismiss');
                            })
                            .catch(e => {
                                console.log(e)
                                this.showSnack('Error', 'Task Created Successfully, But could not fetch', 'Close', 'red')
                            })
                    })
                    .catch((e) => {
                        this.addingTask = false;
                        // eslint-disable-next-line
                        console.log(e)
                        this.showSnack('Error', 'Network error. Please try again.', 'Close', 'red')
                    })

            },
            createTaskSMTPMailbox() {
                this.addingTask = true;

                let jBody = {
                    workflow: this.selectedWorkflow.id,
                    user: this.selectedUser.id,
                    folder: this.selectedFolder.id,
                    title: this.taskTitle,
                    mail: this.mail
                };

                this.fetch({method: 'POST', url:`/SMTP/createAndLinkMailToTaskMailbox/${this.userInfo.entityID}/${this.userInfo.userID}`, body: JSON.stringify(jBody)})
                        .then((data) => {

                            this.getTaskHeader(data.taskID)
                                    .then((task) => {
                                        task.structure = {};
                                        task.structure.steps = [];
                                        task.structure.mails = [];
                                        task.structure.fields = [];
                                        task.structure.draftMails = [];
                                        task.structure.draftNotes = [];

                                        this.$emit('pushTask', task);
                                        eventBus.$emit('snackCreateTask', task);
                                        this.addingTask = false;
                                        this.$emit('dismiss');
                                    })
                                    .catch(e => {
                                        console.log(e)
                                        this.showSnack('Error', 'Task Created Successfully, But could not fetch', 'Close', 'red')
                                    })
                        })
                        .catch((e) => {
                            this.addingTask = false;
                            // eslint-disable-next-line
                            console.log(e)
                            this.showSnack('Error', 'Network error. Please try again.', 'Close', 'red')
                        })

            },
            createTaskOfficeMail() {
                this.addingTask = true;

                let jBody = {
                    workflow: this.selectedWorkflow.id,
                    user: this.selectedUser.id,
                    folder: this.selectedFolder.id,
                    title: this.taskTitle,
                    mail: this.mail
                };

                this.fetch({method: 'POST', url:`/microsoft/createAndLinkMailToTask/${this.userInfo.entityID}/${this.userInfo.userID}`, body: JSON.stringify(jBody)})
                    .then((data) => {
                        this.getTaskHeader(data.taskID)
                            .then(task => {
                                task.structure = {};
                                task.structure.steps = [];
                                task.structure.mails = [];
                                task.structure.fields = [];
                                task.structure.draftMails = [];
                                task.structure.draftNotes = [];

                                this.$emit('pushTask', task);
                                eventBus.$emit('snackCreateTask', task);
                                eventBus.$emit('mailLinkedToTaskOffice', {mail: this.mail, task: task});
                                this.addingTask = false;
                                this.$emit('dismiss');
                            })
                            .catch(err => {console.log(err)})
                    })
                    .catch((e) => {
                        this.addingTask = false;
                        // eslint-disable-next-line
                        console.log(e)
                        this.showSnack('Error', 'Network error. Please try again.', 'Close', 'red')
                    })

            },
          async createTaskZohoMail() {
            try {
              this.addingTask = true;
              
              let jBody = {
                workflow: this.selectedWorkflow.id,
                user: this.selectedUser.id,
                folder: this.selectedFolder.id,
                title: this.taskTitle,
                payload: this.mail
              };
              
              const data = await this.$newReq('POST', `zoho/createAndLinkTaskToMail`, jBody)
              const task = await this.getTaskHeader(data.taskID)
              task.structure = {};
              task.structure.steps = [];
              task.structure.mails = [];
              task.structure.fields = [];
              task.structure.draftMails = [];
              task.structure.draftNotes = [];
              
              this.$emit('pushTask', task);
              eventBus.$emit('snackCreateTask', task);
              eventBus.$emit('mailLinkedToTaskOffice', {mail: this.mail, task: task});
              this.addingTask = false;
              this.$emit('dismiss');
            } catch (e) {
              console.log(e)
              this.$snack.networkError()
            } finally {
              this.addingTask = false;
            }
            
          },
            createTaskGroupMailbox() {
                this.addingTask = true;
                let jBody = {
                    workflow: this.selectedWorkflow.id,
                    user: this.selectedUser.id,
                    folder: this.selectedFolder.id,
                    title: this.taskTitle,
                    mailDBID: this.mailDBID,
                    mail: this.mail,
                };

                this.fetch({method: 'PATCH', url:`/gmail/msg/createAndLinkMailBoxMailToTask/${this.userInfo.entityID}/${this.userInfo.userID}`, body: JSON.stringify(jBody)})
                    .then((data) => {
                        this.getTaskHeader(data.taskID)
                            .then(task => {
                                task.structure = {};
                                task.structure.steps = [];
                                task.structure.mails = [];
                                task.structure.fields = [];
                                task.structure.draftMails = [];
                                task.structure.draftNotes = [];

                                this.$emit('pushTask', task);
                                eventBus.$emit('snackCreateTask', task);
                                eventBus.$emit('mailLinkedToTask', {mail: this.mail, task: task});
                                this.addingTask = false;
                                this.$emit('dismiss')
                            })
                            .catch(err => {console.log(err)})


                    })
                    .catch((e) => {
                        // eslint-disable-next-line
                        console.log(e)
                        this.addingTask = false;
                        this.showSnack('Error', 'Network error. Please try again.', 'Close', 'red')
                    })
            },
            createTaskSplitTask() {

                this.addingTask = true;
                let jBody = {
                    workflow: this.selectedWorkflow.id,
                    user: this.selectedUser.id,
                    folder: this.selectedFolder.id,
                    title: this.taskTitle
                };

                this.fetch({method: 'POST', url:`/tasks/${this.userInfo.entityID}/${this.userInfo.userID}/${this.task.taskID}`, body: JSON.stringify(jBody)})
                    .then((data) => {
                        this.getTaskHeader(data.taskID)
                            .then(task => {
                                task.structure = {};
                                task.structure.steps = [];
                                task.structure.mails = [];
                                task.structure.fields = [];
                                task.structure.draftMails = [];
                                task.structure.draftNotes = [];

                                this.addingTask = false;

                                this.$emit('taskCreated', task);

                                this.$emit('dismiss');

                                if (typeof this.splitData.openOnCreate !== 'undefined' && this.splitData.openOnCreate) {
                                    // setTimeout(() => {
                                    //
                                    // }, 500)
                                    this.$nextTick(() => {
                                        eventBus.$emit('taskCreated', task);
                                    })
                                }
                            })
                            .catch(err => {console.log(err)})
                    })
                    .catch((e) => {
                        // eslint-disable-next-line
                        console.log(e)
                        this.addingTask = false;
                        this.showSnack('Error', 'Network error. Please try again.', 'Close', 'red')
                    })
            },
            taskCheck() {
                if (this.selectedFolder.id != 0) {
                    this.tasksLoading = true;

                    this.fetch({method: 'GET', url:`/tasks/duplicateTaskCheck/${this.userInfo.entityID}/${this.selectedWorkflow.id}/${this.selectedFolder.id}`})
                        .then((similarTasks) => {
                            this.tasks = similarTasks;
                            this.tasksLoading = false;
                        })
                        .catch((e) => {
                            // eslint-disable-next-line
                            console.log(e)
                            this.showSnack('Error', 'Network error. Please try again.', 'Close', 'red')
                        })
                }
            },
            navigateToTask(task) {
                this.dialog = false;
                eventBus.$emit('gotoTask', (task));
            },
            linkMail(task) {

                this.addingTask = true;

                let url = this.mailBoxTask == false ? '/gmail/msg/linkMailToTask/' + this.userInfo.entityID + '/' + this.userInfo.userID + '/' + task.taskID : '/gmail/msg/linkMailboxMailToTask/' + this.userInfo.entityID + '/' + this.userInfo.userID + '/' + task.taskID;

                this.fetch({method: 'PATCH', url: url, body: JSON.stringify(this.mail),})
                    .then(() => {
                        eventBus.$emit('snackLinkTask', task);

                        eventBus.$emit('mailLinkedToTask', {mail: this.mail, task: task});

                        this.$emit('dismiss')
                        this.addingTask = false;
                    })
                    .catch((e) => {
                        // eslint-disable-next-line
                        console.log(e)
                        this.showSnack('Error', 'Network error. Please try again.', 'Close', 'red')
                        this.addingTask = false;
                    });
            },
        },
        computed: {
            sortedSuggestedTasks() {
                if (Array.isArray(this.tasks)) {
                    return this.tasks.filter(() => true).sort((a,b) => a > b ? -1 : 1);
                } else {
                    return []
                }
            },


            filteredWorkflows() {
                let tWorkspaces = [];

                this.workflows.forEach(workspace => {
                    let tWorkflowGroups = [];
                    workspace.children.forEach(workflowGroup => {
                        let tWorkflows = [];
                        workflowGroup.children.forEach(workflow => {
                            if (workflow.description.toLowerCase().includes(this.workflowFilterString.toLowerCase())) {
                                tWorkflows.push({...workflow, key: `wf${workflow.id}`})
                            }
                        });
                        if (tWorkflows.length > 0) {
                            tWorkflowGroups.push({
                                key: `wg${workflowGroup.id}`,
                                id: workflowGroup.id,
                                description: workflowGroup.description,
                                children: tWorkflows
                            })
                        }
                    });
                    if (tWorkflowGroups.length > 0) {
                        tWorkspaces.push({
                            key: `ws${workspace.id}`,
                            id: workspace.id,
                            description: workspace.description,
                            children: tWorkflowGroups
                        })
                    }
                });

                let result = tWorkspaces.map(obj => {
                    obj.children = obj.children.map(workflowGroup => {
                        workflowGroup.children = workflowGroup.children.filter(() => true).sort((a,b) => a['description'] < b['description'] ? -1 : 1)
                        return workflowGroup
                    }).sort((a,b) => a['description'] < b['description'] ? -1 : 1);
                    return obj
                }).sort((a,b) => a['description'] < b['description'] ? -1 : 1);

                return result
            },

            loadUsers() {
                if (this.selectedWorkflow != null && this.selectedFolder != null) {
                    this.loadUsersSplit();
                    this.updateTitle(typeof this.selectedWorkflow.defaultTitle != `undefined` && !this.blankString(this.selectedWorkflow.defaultTitle) ? this.selectedWorkflow.defaultTitle : `${this.selectedWorkflow.description} for ${this.selectedFolder.id === 0 ? 'Task Folder' : this.selectedFolder.description}`);
                    this.taskCheck();
                    return true
                } else {
                    this.updateTitle("");
                    return false;
                }
            }
        }
    }
</script>

<style scoped>
    .taskSelected {
        background: #ebebeb;
    }

    .taskHeader:hover {
        cursor: pointer;
        background: #f9f9f9;
    }
</style>
